import * as React from "react";

function IconMicrophone2({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-microphone-2" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/microphone-2"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M15.002 12.9a5 5 0 1 0 -3.902 -3.9" /><path d="M15.002 12.9l-3.902 -3.899l-7.513 8.584a2 2 0 1 0 2.827 2.83l8.588 -7.515z" /></svg>;
}

export default IconMicrophone2;